import React, { useMemo } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import { ImageStyled } from './styles'
import { ImageProps } from './types'

const Image: React.FC<ImageProps> = ({ fluid, objectFit = 'contain', objectPosition, alt, loading = 'eager' }) => {
  const image = useMemo(() => getImage(fluid)!, [fluid])

  return (
    <ImageStyled>
      <GatsbyImage
        {...{
          image,
          alt,
          objectPosition,
          loading,
          objectFit
        }}
      />
    </ImageStyled>
  )
}
export default Image
